export default {
  component: () => import("../../../template/Default.vue"),
  children: [
    {
      path: "",
      name: "dashboard",
      component: () => import("../components/Dashboard"),
    },
  ],
};
